import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="acknowledge-notice"
export default class extends Controller {
  static targets = [ "template", 'trigger' ]
  
  connect() {
    if (!this.hasTemplateTarget) {
      return
    }

    const config = {
      html: true,
      container: "body",
      trigger: "manual",
      content: this.templateTarget.innerHTML
    }

    $(this.triggerTarget).popover(config)
  }

  confirm() {
      this.dispatch("confirmed", {})
  }
  
  decline() {
    $(this.triggerTarget).popover('hide')
  }

  show(event) {
    event.stopPropagation();
    event.preventDefault();
    
    if (!this.hasTemplateTarget) {
      this.dispatch("confirmed", {})
      return;
    }
    
    $(this.triggerTarget).popover('show')
  }
}
